import PropTypes from 'prop-types'

const campaignShape = PropTypes.shape({
    id: PropTypes.number, // Option[Int]
    requestType: PropTypes.string, // Option[String]
    codificationContext: PropTypes.string, // Option[String]
    name: PropTypes.string, // Option[String]
    beginningApplication: PropTypes.number, // Option[String]
    endingApplication: PropTypes.number, // Option[String]
    comment: PropTypes.string, // Option[String]
    contributorCode: PropTypes.string, // Option[String]
    contactName: PropTypes.string, // Option[String]
    recipientCode: PropTypes.string, // Option[String]
    payerCode: PropTypes.string, // Option[String]
    samplerCode: PropTypes.string, // Option[String]
    supportCode: PropTypes.string, // Option[String]
    campaignType: PropTypes.string, // Option[Int]
    authorizedBancarisation: PropTypes.bool, // Option[String]
    contactCode: PropTypes.string, // Option[Int]
    updateLogin: PropTypes.string, // Option[String]
    updateDate: PropTypes.number, // Option[DateTime]
    statut: PropTypes.string, // Option[Int]
    administratorCode: PropTypes.string, //  Option[Int]
    stationType: PropTypes.string, // Option[Long]
    marketRef: PropTypes.string, // Option[String]
    eventCount: PropTypes.number, // Option[String]
    selections: PropTypes.arrayOf(PropTypes.string), // Option[Seq[String]]
    secondaryContacts: PropTypes.arrayOf(PropTypes.number), // Option[Seq[Double]]
    secondaryLabos: PropTypes.arrayOf(PropTypes.number), // Option[Seq[Double]]
})

const campaignObjectiveShape = PropTypes.shape({
    id: PropTypes.number, // Long
    campaignCode: PropTypes.number, // Double
    objectiveCode: PropTypes.number, // Int
})

const stationCampaignPlanningShape = PropTypes.shape({
    id: PropTypes.number, // Long
    campaignCode: PropTypes.number, // Double
    startDate: PropTypes.number, // DateTime
    endDate: PropTypes.number, // DateTime
    producer: PropTypes.number, // Option[Int] — premier agent
    producers: PropTypes.arrayOf(PropTypes.number), // Array[Int]
    stationsPlan: PropTypes.arrayOf(PropTypes.number), // Array[Long]
    objectivesPlan: PropTypes.arrayOf(PropTypes.number), // Array[Long]
})

const stationCampaignPlanningExceptionShape = PropTypes.shape({
    id: PropTypes.number, // Option[Long]
    planningId: PropTypes.number, // Long
    stationsPlan: PropTypes.arrayOf(PropTypes.number), // Array[Long]
    objectivesToAddPlan: PropTypes.arrayOf(PropTypes.number), // Array[Long]
    objectivesToDeletePlan: PropTypes.arrayOf(PropTypes.number), // Array[Long]
})

export {
    campaignShape,
    campaignObjectiveShape,
    stationCampaignPlanningShape,
    stationCampaignPlanningExceptionShape,
}
